import Joi from 'joi';

const ThreeDsPreference = Joi.string().allow('');

export default ThreeDsPreference;
